const FREE = 9 // 9以下はフリープラン(未契約)
const FREE_NAME = 'フリープラン'
const STARTER = 10
const STARTER_NAME = 'スタータープラン'
const TRIAL = 11
const TRIAL_NAME = 'トライアルプラン'
const MANAGER = 12
const MANAGER_NAME = 'マネージャープラン'
const STANDARD = 13
const STANDARD_NAME = 'スタンダードプラン'
const PARTNER = 14
const PARTNER_NAME = 'パートナープラン'
const PRO = 15
const PRO_NAME = 'プロプラン'
const ENTERPRISE = 17 // 17以上はエンタープライズプラン
const ENTERPRISE_NAME = 'エンタープライズプラン'
const ADMIN = 20 // 管理者プラン(社内のみ)
const ADMIN_NAME = '管理者プラン'

const PLAN_LIST = {
  [FREE]: FREE_NAME,
  [STARTER]: STARTER_NAME,
  [TRIAL]: TRIAL_NAME,
  [MANAGER]: MANAGER_NAME,
  [STANDARD]: STANDARD_NAME,
  [PARTNER]: PARTNER_NAME,
  [PRO]: PRO_NAME,
  [ENTERPRISE]: ENTERPRISE_NAME,
  [ADMIN]: ADMIN_NAME,
}

export {
  FREE,
  FREE_NAME,
  STARTER,
  STARTER_NAME,
  TRIAL,
  TRIAL_NAME,
  MANAGER,
  MANAGER_NAME,
  STANDARD,
  STANDARD_NAME,
  PARTNER,
  PARTNER_NAME,
  PRO,
  PRO_NAME,
  ENTERPRISE,
  ENTERPRISE_NAME,
  ADMIN,
  ADMIN_NAME,
  PLAN_LIST,
}